/**
 * Created by JurY on 16/06/17.
 */

angular.module("screensApp")

  .controller("HelpGuidesController", function ($scope, $rootScope) {
    // Show Help guide
    $rootScope.showHelpSRT = function () {
      $scope.helpImg = "../images/guides/helpSRT-" + $rootScope.config.LanguageId;
      if (["$"].includes($rootScope.config.CurrencyId) && ["en"].includes($rootScope.config.LanguageId)) {
        $scope.helpImg += "-" + $rootScope.config.CurrencyId;
      }
      $scope.helpImg += ".jpg";
      $rootScope.settings.helpSRT.show = true;
      $rootScope.$$phase || $rootScope.$apply();
    };

    // Hide Help guide
    $rootScope.hideHelpSRT = function () {
      $rootScope.settings.helpSRT.show = false;
      $rootScope.$$phase || $rootScope.$apply();
    };
  });
